module.exports = __webpack_public_path__ + "media/images/app/products/index/occassions/wedding-8159e6f3e93c319b499aa61902c29560.webp";